import { Link } from "react-router-dom";
import { Linkedin, Github, Twitter } from "lucide-react";
import { SITE } from "@/config/site";

export function Footer() {
  const socials = [
    { key: "linkedin", url: SITE.socials.linkedin, Icon: Linkedin, label: "LinkedIn" },
    { key: "github", url: SITE.socials.github, Icon: Github, label: "GitHub" },
    { key: "x", url: SITE.socials.x, Icon: Twitter, label: "X" },
  ].filter((s) => s.url);

  return (
    <footer
      data-testid="site-footer"
      className="bg-steel-deep text-slate-400 py-10 border-t border-slate-800"
    >
      <div className="max-w-6xl mx-auto px-6 flex flex-col sm:flex-row items-center justify-between gap-4 text-xs font-mono-sub">
        <div className="flex items-center gap-3">
          <img
            src="/logo-white.png"
            alt={SITE.companyName}
            data-testid="footer-logo"
            className="h-7 w-auto"
            width="107"
            height="28"
          />
          <span>· {SITE.domain.replace("https://", "")}</span>
        </div>
        <nav className="flex flex-wrap justify-center gap-6" aria-label="Footer">
          <Link data-testid="footer-link-services" to="/services" className="hover:text-white transition-colors">
            Services
          </Link>
          <Link data-testid="footer-link-process" to="/process" className="hover:text-white transition-colors">
            Process
          </Link>
          <Link data-testid="footer-link-products" to="/products" className="hover:text-white transition-colors">
            Products
          </Link>
          <Link data-testid="footer-link-reviews" to="/reviews" className="hover:text-white transition-colors">
            Reviews
          </Link>
          <Link data-testid="footer-link-about" to="/about" className="hover:text-white transition-colors">
            About
          </Link>
          <Link data-testid="footer-link-contact" to="/contact" className="hover:text-white transition-colors">
            Contact
          </Link>
        </nav>
        <div className="flex items-center gap-4">
          {socials.map(({ key, url, Icon, label }) => (
            <a
              key={key}
              href={url}
              data-testid={`footer-social-${key}`}
              target="_blank"
              rel="noopener noreferrer"
              aria-label={label}
              className="hover:text-white transition-colors"
            >
              <Icon className="w-4 h-4" />
            </a>
          ))}
          <span>Remote Worldwide Operations</span>
        </div>
      </div>
    </footer>
  );
}
